export default "__VITE_ASSET__3f9993e4__"